module.exports = __webpack_public_path__ + "static/media/dice_1.e13e6be9.svg";